import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { getProductsProductsGet } from "@/client/sdk.gen";

export function useProductsQuery() {
  const [searchParams] = useSearchParams();

  // Parse filters from URL
  const brands = searchParams.get('brands');
  const categories = searchParams.get('categories');
  const sites = searchParams.get('sites');
  const sizes = searchParams.get('sizes');
  const conditions = searchParams.get('conditions');
  const stock = searchParams.get('in_stock') === 'true' ? true : searchParams.get('in_stock') === 'false' ? false : null;
  const min_price = searchParams.get('min_price');
  const max_price = searchParams.get('max_price');
  const days_since_update = Number(searchParams.get('days_since_update'));
  const searchQuery = searchParams.get('search');
  const sortBy = searchParams.get('sort') || 'created_at';

  const limit = 20;

  return useInfiniteQuery({
    queryKey: [
      'products',
      brands ?? '',
      categories ?? '',
      sites ?? '',
      stock ?? '',
      searchQuery ?? '',
      sortBy,
      limit,
    ],
    queryFn: async ({ pageParam }) => {
      const res = await getProductsProductsGet({
        query: {
          brand_ids: brands,
          category_ids: categories,
          site_ids: sites,
          sizes: sizes,
          condition: conditions,
          in_stock: stock,
          min_price: min_price,
          max_price: max_price,
          days_since_update: days_since_update == 0 ? null : days_since_update,
          search: searchQuery,
          sort_by: sortBy,
          offset: pageParam * limit,
          limit,
        },
      });
      return res.data ?? null;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage) return undefined;
      const nextOffset = lastPage.offset + 20;
      if (nextOffset >= lastPage.total) {
        return undefined;
      }
      return nextOffset / 20;
    },
    placeholderData: (previousData) => previousData,
  });
}